/** The reasons a declaration is HELD: processed, nothing staged, and a
 *  visible explanation instead of an empty row. `blank_template` is the
 *  round-trip hold (our own template came back unsigned), `unfilled_form` the
 *  extraction hold (a customer form came back with no box ticked). `other` is
 *  the generic fallback (TUR-1211 wave 3): an `extraction_hold` reason this
 *  frontend does not yet recognise still means the row is HELD, never the
 *  same "all clear" chip a genuinely clean row gets. One derived reason, so
 *  every surface (list pill, panel, Studio V2) reads the same answer and a
 *  later reason lands in exactly one place. */
export type HoldReason = "blank_template" | "unfilled_form" | "other"

const KNOWN: ReadonlySet<string> = new Set<HoldReason>([
  "blank_template",
  "unfilled_form",
])

export function holdReasonOf(row: {
  roundtripHold?: string
  extractionHold?: string
}): HoldReason | null {
  for (const candidate of [row.roundtripHold, row.extractionHold]) {
    if (candidate && KNOWN.has(candidate)) return candidate as HoldReason
  }
  // An unrecognised, non-empty extraction_hold still HOLDS the row, never
  // silently read as clean. `roundtripHold` carries exactly one known value
  // today, so an unrecognised one there stays `null` rather than guessing.
  if (row.extractionHold) return "other"
  return null
}
